// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__d2gJ2","notLoading":"Loading_notLoading__zB-Ni","loader":"Loading_loader__uwVLQ","loading":"Loading_loading__GLndB"};